import { Component, OnInit, HostBinding, ViewChild, TemplateRef, Injector, Optional, ChangeDetectorRef, LOCALE_ID, Inject } from '@angular/core';
import { DatagridComponent } from '@farris/ui-datagrid';
import { Subject } from 'rxjs/Subject';
import { MessagerService } from '@farris/ui-messager';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../../i18n/assets/lang.resource';

@Component({
  selector: 'app-enum-list',
  templateUrl: './enum-list.component.html',
  styleUrls: ['./enum-list.component.scss'],
  providers: [
     WfLocalePipe,
  ]
})
export class EnumListComponent implements OnInit {

  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  columns = [
    { field: 'key', width: 100, title: this.localePipe.transform('component.matrixPerformer.key') },
    { field: 'value', width: 100, title: this.localePipe.transform('component.matrixPerformer.value')}];
  @ViewChild('dg') dg: DatagridComponent;
  @ViewChild('buttons') btnRef: TemplateRef<any>;

  confirm = new Subject<any>();
  closeModalEmitter = new Subject<any>();

  /**
   * 显示值
   */
  data = new Array();

  selectedIds = new Array();

  constructor(
    private messageService: MessagerService,
    private injector: Injector,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {

  }

  /**
   * 加载显示数据
   */
  load(enumValues) {
    this.data = [...enumValues];
  }

  /**
   * 确认
   */
  onConfirm(): void {
    if (this.selectedIds.length === 0 ) {
      this.messageService.warning(this.localePipe.transform('component.matrixPerformer.notSelectEnum'));
    }
    const enumValues = this.data.filter(d => this.selectedIds.findIndex(id => id === d.key) > -1);
    this.confirm.next(enumValues);
    this.closeModalEmitter.next();
  }

  /**
   * 取消
   */
  cancel(): void {
    this.closeModalEmitter.next();
  }

}
